/* START POLISH */
/* 3-9-2026 — Optivaize. Mobiel (productpagina):
   punt 3: "+ Toevoegen"-knop in de kaarten van "Voeg toe aan deze spa" (thema-blok complementary), zelfde gedrag als de accessoire-kaart;
   punt 4: dots bij de showroom-carrousel (media-grid). Geen autorotatie. Terugdraaien: include in layout/theme.liquid verwijderen. */
(function () {
  var MOBILE = window.matchMedia('(max-width: 768.98px)');

  /* ---------- punt 3 ---------- */
  function addLabel() { return '+ Toevoegen'; }
  function bindCard(card) {
    if (card.querySelector('.ft-pl-add')) return;
    var link = card.querySelector('a.card-link') || card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = m[1];
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'ft-pl-add'; btn.textContent = addLabel(); btn.setAttribute('aria-label', 'Toevoegen aan winkelwagen');
    btn.addEventListener('click', function () {
      btn.disabled = true; btn.textContent = 'Toevoegen…';
      fetch('/products/' + handle + '.js').then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
          if (!v) throw new Error('geen variant');
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) });
        })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () {
          btn.textContent = '✓ Toegevoegd'; btn.classList.add('is-done');
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('on:cart:add', { detail: { cart: cart } }));
          });
        })
        .catch(function () { btn.disabled = false; btn.textContent = addLabel(); });
    });
    card.appendChild(btn);
  }
  function scanComplementary() {
    if (!MOBILE.matches) return;
    document.querySelectorAll('product-recommendations[data-url*="intent=complementary"] .card--related').forEach(bindCard);
  }
  function watchComplementary() {
    document.querySelectorAll('product-recommendations[data-url*="intent=complementary"]').forEach(function (host) {
      if (host.__ftPl) return; host.__ftPl = true;
      new MutationObserver(scanComplementary).observe(host, { childList: true, subtree: true });
    });
    scanComplementary();
  }

  /* ---------- punt 4 ---------- */
  function initDots(gallery) {
    if (gallery.__ftDots) return; gallery.__ftDots = true;
    var slides = gallery.querySelectorAll('.gallery-block');
    if (slides.length < 2) return;
    var dots = document.createElement('div'); dots.className = 'ft-pl-dots'; dots.setAttribute('role', 'tablist'); dots.setAttribute('aria-label', 'Showroomfoto\'s');
    var btns = [];
    slides.forEach(function (s, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Foto ' + (i + 1) + ' van ' + slides.length);
      b.addEventListener('click', function () { gallery.scrollTo({ left: s.offsetLeft - gallery.offsetLeft, behavior: 'smooth' }); });
      dots.appendChild(b); btns.push(b);
    });
    gallery.insertAdjacentElement('afterend', dots);
    var raf = null;
    function update() {
      raf = null;
      var x = gallery.scrollLeft, best = 0, bd = Infinity;
      slides.forEach(function (s, i) { var d = Math.abs((s.offsetLeft - gallery.offsetLeft) - x); if (d < bd) { bd = d; best = i; } });
      btns.forEach(function (b, i) { b.classList.toggle('is-active', i === best); b.setAttribute('aria-selected', i === best ? 'true' : 'false'); });
    }
    gallery.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    update();
  }
  function initCarousels() {
    if (!MOBILE.matches) return;
    document.querySelectorAll('[id$="__media_grid_UJNfBp"] .gallery, [id$="__media_grid_DcpCCe"] .gallery').forEach(initDots);
  }

  function init() { watchComplementary(); initCarousels(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
/* EINDE POLISH */
